__turbopack_context__.v({
  "bottomNav": "MobileNavigation-module__RnA4EG__bottomNav",
  "bottomNavLink": "MobileNavigation-module__RnA4EG__bottomNavLink",
  "bottomNavList": "MobileNavigation-module__RnA4EG__bottomNavList",
  "logoutButton": "MobileNavigation-module__RnA4EG__logoutButton",
  "mobileHeader": "MobileNavigation-module__RnA4EG__mobileHeader",
});
